"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/tooltip/style");
var _tooltip = _interopRequireDefault(require("antd/lib/tooltip"));
require("antd/lib/badge/style");
var _badge = _interopRequireDefault(require("antd/lib/badge"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
var _react = _interopRequireWildcard(require("react"));
var _antdMaskInput = _interopRequireDefault(require("antd-mask-input"));
var _utils = require("../../utils");
var _EditableInput = require("../EditableInput");
var _components = require("../../components");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var phoneValidator = (0, _utils.phoneValidator)();
var fieldName = 'phoneNumber';
var EditablePhoneNumber = function EditablePhoneNumber(_ref) {
  var form = _ref.form,
    loading = _ref.loading,
    phoneNumber = _ref.phoneNumber,
    phoneDeliveryPreference = _ref.phoneDeliveryPreference,
    phoneSmsCompatible = _ref.phoneSmsCompatible,
    phoneStatus = _ref.phoneStatus,
    phoneType = _ref.phoneType,
    onSubmit = _ref.onSubmit,
    _ref$active = _ref.active,
    active = _ref$active === void 0 ? false : _ref$active,
    forceSubmitButtonRender = _ref.forceSubmitButtonRender,
    _ref$narrowView = _ref.narrowView,
    narrowView = _ref$narrowView === void 0 ? false : _ref$narrowView,
    controlsWrapperStyling = _ref.controlsWrapperStyling;
  var getFieldDecorator = form.getFieldDecorator,
    isFieldValidating = form.isFieldValidating,
    setFieldsValue = form.setFieldsValue;
  var _useState = (0, _react.useState)(active),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var onEdit = (0, _react.useCallback)(function () {
    return setIsActive(true);
  }, []);
  var validationErrors = Object.values(form.getFieldsError()).some(function (v) {
    return v;
  });
  var isValidating = isFieldValidating(fieldName);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err, values) {
        var newPhoneNumber;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!err) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                newPhoneNumber = (0, _utils.trimPhoneNumber)(values[fieldName]);
                if (!(forceSubmitButtonRender || newPhoneNumber !== phoneNumber)) {
                  _context.next = 7;
                  break;
                }
                _context.next = 6;
                return onSubmit({
                  phoneNumber: newPhoneNumber
                });
              case 6:
                if (active) {
                  setIsActive(false);
                }
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  };
  var resetFieldsValue = (0, _react.useCallback)(function () {
    if (phoneNumber) {
      setFieldsValue(_defineProperty({}, fieldName, phoneNumber));
    }
    setIsActive(false);
  }, [phoneNumber, setFieldsValue]);
  var phoneValidationDetails = (0, _utils.phoneNumberSMSCompatibilityDetails)({
    phoneSmsCompatible: phoneSmsCompatible,
    phoneDeliveryPreference: phoneDeliveryPreference,
    phoneType: phoneType,
    phoneStatus: phoneStatus
  });
  var isMobileView = (0, _utils.isMobile)();
  (0, _react.useEffect)(function () {
    setIsActive(active);
  }, [active]);
  var addonAfter = (0, _react.useMemo)(function () {
    var editButton = /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: onEdit,
      shape: "circle",
      type: "link"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      className: "icon-pencil"
    }));
    if (!phoneValidationDetails) {
      return editButton;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isMobileView || !narrowView ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: phoneValidationDetails.description
    }, /*#__PURE__*/_react.default.createElement(_badge.default, {
      status: phoneValidationDetails.status,
      text: phoneValidationDetails.message,
      style: {
        marginRight: '10px'
      }
    })), editButton) : editButton);
  }, [onEdit, phoneDeliveryPreference, phoneSmsCompatible, phoneType, phoneStatus]);
  var formComponent = /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "change-phone-number-form"
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, null, getFieldDecorator(fieldName, {
    initialValue: _utils.PhoneNumberUtils.getNationalNumber(phoneNumber),
    rules: [{
      required: true,
      message: 'Please enter a phone number'
    }, {
      validator: phoneValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_EditableInput.EditableInput, {
    active: isActive,
    addonAfter: addonAfter,
    disabled: !!validationErrors,
    editable: !!onSubmit,
    InputComponent: _antdMaskInput.default,
    mask: "(111) 111-1111",
    name: fieldName,
    onChange: function onChange(e) {
      return _defineProperty({}, e.target.name, e.target.value);
    },
    onEdit: onEdit,
    placeholder: "Phone Number (i.e. (555) 555-5555)",
    processing: isValidating || loading,
    saveButton: null,
    addonBefore: /*#__PURE__*/_react.default.createElement(_components.PhoneInputConsent, null)
  }))), (isActive || forceSubmitButtonRender) && /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_row.default, {
    className: (0, _classnames.default)('flex items-baseline', controlsWrapperStyling)
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    htmlType: "submit",
    size: "small",
    disabled: !forceSubmitButtonRender && (loading || validationErrors || phoneNumber === (!active && (0, _utils.trimPhoneNumber)(form.getFieldValue(fieldName)) || ''))
  }, "Verify")), isActive && /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    htmlType: "button",
    disabled: loading,
    size: "small",
    onClick: resetFieldsValue
  }, "cancel")))));
  return isMobileView && phoneValidationDetails && narrowView ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: phoneValidationDetails.description,
    placement: "bottom",
    defaultVisible: true
  }, formComponent) : formComponent;
};
var _default = _form.default.create({
  name: 'EditablePhoneNumber'
})(EditablePhoneNumber);
exports.default = _default;